export function getdata(){
	var obj = {
		
			headDataI: [{
					title: "项目",
					prop: 'title',
					width: "280px",
					custom: true,
				},
				{
					title: "行次",
					prop: 'grade',
					width: "100px",
				},
				{
					title: "金额",
					prop: "cwbbqykjzd_2_x_1",
					custom: true,
					width: "200px"
				},
			],
			headDataII: [{
					title: "项目",
					prop: 'title',
					width: "280px",
					custom: true,
				},
				{
					title: "行次",
					prop: 'grade',
					width: "100px",
				},
				{
					title: "金额",
					prop: "cwbbqykjzd_2_x_1",
					custom: true,
					width: "200px"
				},
			],
			tableDataII:[{
					title: "1．将净利润调节为经营活动现金流量：",
					grade: '',
					disabledcwbbqykjzd_2_x_1: false,
					cwbbqykjzd_2_x_1: {
						cellCode: "cwbbwxz_1_1_1",
						cellType: "1",
						cellVal: "240040043.08"
					},
				},
				{
					title: "净利润",
					grade: '57',
					disabledcwbbqykjzd_2_x_1: false,
					cwbbqykjzd_2_x_1: {
						cellCode: "cwbbwxz_1_2_1",
						cellType: "1",
						cellVal: "240040043.08"
					},
				}, {
					title: "加：计提的资产减值准备",
					grade: '58',
					disabledcwbbqykjzd_2_x_1: false,
					cwbbqykjzd_2_x_1: {
						cellCode: "cwbbwxz_1_3_1",
						cellType: "1",
						cellVal: "240040043.08"
					},
				}, {
					title: "固定资产折旧",
					grade: '59',
					disabledcwbbqykjzd_2_x_1: false,
					cwbbqykjzd_2_x_1: {
						cellCode: "cwbbwxz_1_4_1",
						cellType: "1",
						cellVal: "240040043.08"
					},
				}, {
					title: "无形资产摊销",
					grade: '60',
					disabledcwbbqykjzd_2_x_1: false,
					cwbbqykjzd_2_x_1: {
						cellCode: "cwbbwxz_1_5_1",
						cellType: "1",
						cellVal: "240040043.08"
					},
				}, {
					title: "长期待摊费用摊销",
					grade: '61',
					disabledcwbbqykjzd_2_x_1: false,
					cwbbqykjzd_2_x_1: {
						cellCode: "cwbbwxz_1_6_1",
						cellType: "1",
						cellVal: "240040043.08"
					},
				}, {
					title: "待摊费用减少(减：增加)",
					grade: '64',
					disabledcwbbqykjzd_2_x_1: false,
					cwbbqykjzd_2_x_1: {
						cellCode: "cwbbwxz_1_6_1",
						cellType: "1",
						cellVal: "240040043.08"
					},
				}, {
					title: "预提费用增加(减：减少)",
					grade: '65',
					disabledcwbbqykjzd_2_x_1: false,
					cwbbqykjzd_2_x_1: {
						cellCode: "cwbbwxz_1_6_1",
						cellType: "1",
						cellVal: "240040043.08"
					},
				}, {
					title: "处置固定资产、无形资产和其他长期资产的损失(减：收益)",
					grade: '66',
					disabledcwbbqykjzd_2_x_1: false,
					cwbbqykjzd_2_x_1: {
						cellCode: "cwbbwxz_1_6_1",
						cellType: "1",
						cellVal: "240040043.08"
					},
				}, {
					title: "固定资产报废损失",
					grade: '67',
					disabledcwbbqykjzd_2_x_1: false,
					cwbbqykjzd_2_x_1: {
						cellCode: "cwbbwxz_1_6_1",
						cellType: "1",
						cellVal: "240040043.08"
					},
				}, {
					title: "财务费用",
					grade: '68',
					disabledcwbbqykjzd_2_x_1: false,
					cwbbqykjzd_2_x_1: {
						cellCode: "cwbbwxz_1_6_1",
						cellType: "1",
						cellVal: "240040043.08"
					},
				}, {
					title: "投资损失(减：收益)",
					grade: '69',
					disabledcwbbqykjzd_2_x_1: false,
					cwbbqykjzd_2_x_1: {
						cellCode: "cwbbwxz_1_6_1",
						cellType: "1",
						cellVal: "240040043.08"
					},
				}, {
					title: "递延税款贷项(减：借项)",
					grade: '70',
					disabledcwbbqykjzd_2_x_1: false,
					cwbbqykjzd_2_x_1: {
						cellCode: "cwbbwxz_1_6_1",
						cellType: "1",
						cellVal: "240040043.08"
					},
				}, {
					title: "存货的减少(减：增加)",
					grade: '71',
					disabledcwbbqykjzd_2_x_1: false,
					cwbbqykjzd_2_x_1: {
						cellCode: "cwbbwxz_1_6_1",
						cellType: "1",
						cellVal: "240040043.08"
					},
				}, {
					title: "经营性应收项目的减少(减：增加)",
					grade: '72',
					disabledcwbbqykjzd_2_x_1: false,
					cwbbqykjzd_2_x_1: {
						cellCode: "cwbbwxz_1_6_1",
						cellType: "1",
						cellVal: "240040043.08"
					},
				}, {
					title: "经营性应付项目的增加(减：减少)",
					grade: '73',
					disabledcwbbqykjzd_2_x_1: false,
					cwbbqykjzd_2_x_1: {
						cellCode: "cwbbwxz_1_6_1",
						cellType: "1",
						cellVal: "240040043.08"
					},
				}, {
					title: "其他",
					grade: '74',
					disabledcwbbqykjzd_2_x_1: false,
					cwbbqykjzd_2_x_1: {
						cellCode: "cwbbwxz_1_6_1",
						cellType: "1",
						cellVal: "240040043.08"
					},
				}, {
					title: "经营活动产生的现金流量净额",
					grade: '75',
					disabledcwbbqykjzd_2_x_1: false,
					cwbbqykjzd_2_x_1: {
						cellCode: "cwbbwxz_1_6_1",
						cellType: "1",
						cellVal: "240040043.08"
					},
				}, {
					title: "2．不涉及现金收支的投资和筹资活动：",
					grade: '',
					disabledcwbbqykjzd_2_x_1: false,
					cwbbqykjzd_2_x_1: {cellCode: "cwbbwxz_1_6_1",},
				}, {
					title: "债务转为资本",
					grade: '76',
					disabledcwbbqykjzd_2_x_1: false,
					cwbbqykjzd_2_x_1: {
						cellCode: "cwbbwxz_1_6_1",
						cellType: "1",
						cellVal: "240040043.08"
					},
				}, {
					title: "一年内到期的可转换公司债券",
					grade: '77',
					disabledcwbbqykjzd_2_x_1: false,
					cwbbqykjzd_2_x_1: {
						cellCode: "cwbbwxz_1_6_1",
						cellType: "1",
						cellVal: "240040043.08"
					},
				}, {
					title: "融资租入固定资产",
					grade: '78',
					disabledcwbbqykjzd_2_x_1: false,
					cwbbqykjzd_2_x_1: {
						cellCode: "cwbbwxz_1_6_1",
						cellType: "1",
						cellVal: "240040043.08"
					},
				}, {
					title: "3．现金及现金等价物净增加情况：",
					grade: '',
					disabledcwbbqykjzd_2_x_1: false,
					cwbbqykjzd_2_x_1: {cellCode: "cwbbwxz_1_6_1",},
				}, {
					title: "现金的期末余额",
					grade: '79',
					disabledcwbbqykjzd_2_x_1: false,
					cwbbqykjzd_2_x_1: {
						cellCode: "cwbbwxz_1_6_1",
						cellType: "1",
						cellVal: "240040043.08"
					},
				}, {
					title: "减：现金的期初余额",
					grade: '80',
					disabledcwbbqykjzd_2_x_1: false,
					cwbbqykjzd_2_x_1: {
						cellCode: "cwbbwxz_1_6_1",
						cellType: "1",
						cellVal: "240040043.08"
					},
				}, {
					title: "加：现金等价物的期末余额",
					grade: '81',
					disabledcwbbqykjzd_2_x_1: false,
					cwbbqykjzd_2_x_1: {
						cellCode: "cwbbwxz_1_6_1",
						cellType: "1",
						cellVal: "240040043.08"
					},
				}, {
					title: "减：现金等价物的期初余额",
					grade: '82',
					disabledcwbbqykjzd_2_x_1: false,
					cwbbqykjzd_2_x_1: {
						cellCode: "cwbbwxz_1_6_1",
						cellType: "1",
						cellVal: "240040043.08"
					},
				}, {
					title: "现金及现金等价物净增加额",
					grade: '83',
					disabledcwbbqykjzd_2_x_1: false,
					cwbbqykjzd_2_x_1: {
						cellCode: "cwbbwxz_1_6_1",
						cellType: "1",
						cellVal: "240040043.08"
					},
				}
			],
			tableDataI: [{
					title: "一、经营活动产生的现金流量：",
					grade: '',
					disabledcwbbqykjzd_2_x_1: false,
					cwbbqykjzd_2_x_1: {cellCode: "cwbbwxz_1_1_1",},
				},
				{
					title: "销售商品、提供劳务收到的现金",
					grade: '1',
					disabledcwbbqykjzd_2_x_1: false,
					cwbbqykjzd_2_x_1: {
						cellCode: "cwbbwxz_1_2_1",
						cellType: "1",
						cellVal: "240040043.08"
					},
				}, {
					title: "收到的税费返还",
					grade: '3',
					disabledcwbbqykjzd_2_x_1: false,
					cwbbqykjzd_2_x_1: {
						cellCode: "cwbbwxz_1_3_1",
						cellType: "1",
						cellVal: "240040043.08"
					},
				}, {
					title: "收到的其他与经营活动有关的现金",
					grade: '8',
					disabledcwbbqykjzd_2_x_1: false,
					cwbbqykjzd_2_x_1: {
						cellCode: "cwbbwxz_1_4_1",
						cellType: "1",
						cellVal: "240040043.08"
					},
				}, {
					title: "现金流入小计",
					grade: '9',
					disabledcwbbqykjzd_2_x_1: false,
					cwbbqykjzd_2_x_1: {
						cellCode: "cwbbwxz_1_5_1",
						cellType: "1",
						cellVal: "240040043.08"
					},
				}, {
					title: "购买商品、接受劳务支付的现金",
					grade: '10',
					disabledcwbbqykjzd_2_x_1: false,
					cwbbqykjzd_2_x_1: {
						cellCode: "cwbbwxz_1_6_1",
						cellType: "1",
						cellVal: "240040043.08"
					},
				}, {
					title: "支付给职工以及为职工支付的现金",
					grade: '12',
					disabledcwbbqykjzd_2_x_1: false,
					cwbbqykjzd_2_x_1: {
						cellCode: "cwbbwxz_1_7_1",
						cellType: "1",
						cellVal: "240040043.08"
					},
				}, {
					title: "支付的各项税费",
					grade: '13',
					disabledcwbbqykjzd_2_x_1: false,
					cwbbqykjzd_2_x_1: {
						cellCode: "cwbbwxz_1_8_1",
						cellType: "1",
						cellVal: "240040043.08"
					},
				}, {
					title: "支付的其他与经营活动有关的现金",
					grade: '18',
					disabledcwbbqykjzd_2_x_1: false,
					cwbbqykjzd_2_x_1: {
						cellCode: "cwbbwxz_1_9_1",
						cellType: "1",
						cellVal: "240040043.08"
					},
				}, {
					title: "现金流出小计",
					grade: '20',
					disabledcwbbqykjzd_2_x_1: false,
					cwbbqykjzd_2_x_1: {
						cellCode: "cwbbwxz_1_10_1",
						cellType: "1",
						cellVal: "240040043.08"
					},
				}, {
					title: "经营活动产生的现金流量净额",
					grade: '21',
					disabledcwbbqykjzd_2_x_1: false,
					cwbbqykjzd_2_x_1: {
						cellCode: "cwbbwxz_1_11_1",
						cellType: "1",
						cellVal: "240040043.08"
					},
				}, {
					title: "二、投资活动产生的现金流量：",
					grade: '',
					disabledcwbbqykjzd_2_x_1: false,
					cwbbqykjzd_2_x_1: {cellCode: "cwbbwxz_1_12_1",},
				}, {
					title: "收回投资所收到的现金",
					grade: '22',
					disabledcwbbqykjzd_2_x_1: false,
					cwbbqykjzd_2_x_1: {
						cellCode: "cwbbwxz_1_13_1",
						cellType: "1",
						cellVal: "240040043.08"
					},
				}, {
					title: "取得投资收益所收到的现金",
					grade: '23',
					disabledcwbbqykjzd_2_x_1: false,
					cwbbqykjzd_2_x_1: {
						cellCode: "cwbbwxz_1_14_1",
						cellType: "1",
						cellVal: "240040043.08"
					},
				}, {
					title: "处置固定资产、无形资产和其他长期资产所收回的现金净额",
					grade: '25',
					disabledcwbbqykjzd_2_x_1: false,
					cwbbqykjzd_2_x_1: {
						cellCode: "cwbbwxz_1_15_1",
						cellType: "1",
						cellVal: "240040043.08"
					},
				}, {
					title: "收到的其他与投资活动有关的现金",
					grade: '28',
					disabledcwbbqykjzd_2_x_1: false,
					cwbbqykjzd_2_x_1: {
						cellCode: "cwbbwxz_1_16_1",
						cellType: "1",
						cellVal: "240040043.08"
					},
				}, {
					title: "现金流入小计",
					grade: '29',
					disabledcwbbqykjzd_2_x_1: false,
					cwbbqykjzd_2_x_1: {
						cellCode: "cwbbwxz_1_16_1",
						cellType: "1",
						cellVal: "240040043.08"
					},
				},{
					title: "购建固定资产、无形资产和其他长期资产所支付的现金",
					grade: '30',
					disabledcwbbqykjzd_2_x_1: false,
					cwbbqykjzd_2_x_1: {
						cellCode: "cwbbwxz_1_16_1",
						cellType: "1",
						cellVal: "240040043.08"
					},
				},{
					title: "投资所支付的现金",
					grade: '31',
					disabledcwbbqykjzd_2_x_1: false,
					cwbbqykjzd_2_x_1: {
						cellCode: "cwbbwxz_1_16_1",
						cellType: "1",
						cellVal: "240040043.08"
					},
				},{
					title: "支付的其他与投资活动有关的现金",
					grade: '35',
					disabledcwbbqykjzd_2_x_1: false,
					cwbbqykjzd_2_x_1: {
						cellCode: "cwbbwxz_1_16_1",
						cellType: "1",
						cellVal: "240040043.08"
					},
				},{
					title: "现金流出小计",
					grade: '36',
					disabledcwbbqykjzd_2_x_1: false,
					cwbbqykjzd_2_x_1: {
						cellCode: "cwbbwxz_1_16_1",
						cellType: "1",
						cellVal: "240040043.08"
					},
				},{
					title: "投资活动产生的现金流量净额",
					grade: '37',
					disabledcwbbqykjzd_2_x_1: false,
					cwbbqykjzd_2_x_1: {
						cellCode: "cwbbwxz_1_16_1",
						cellType: "1",
						cellVal: "240040043.08"
					},
				},{
					title: "三、筹资活动产生的现金流量：",
					grade: '',
					disabledcwbbqykjzd_2_x_1: false,
					cwbbqykjzd_2_x_1: {cellCode: "cwbbwxz_1_16_1",},
				},{
					title: "吸收投资所收到的现金",
					grade: '38',
					disabledcwbbqykjzd_2_x_1: false,
					cwbbqykjzd_2_x_1: {
						cellCode: "cwbbwxz_1_16_1",
						cellType: "1",
						cellVal: "240040043.08"
					},
				},{
					title: "借款所收到的现金",
					grade: '40',
					disabledcwbbqykjzd_2_x_1: false,
					cwbbqykjzd_2_x_1: {
						cellCode: "cwbbwxz_1_16_1",
						cellType: "1",
						cellVal: "240040043.08"
					},
				},{
					title: "收到的其他与筹资活动有关的现金",
					grade: '43',
					disabledcwbbqykjzd_2_x_1: false,
					cwbbqykjzd_2_x_1: {
						cellCode: "cwbbwxz_1_16_1",
						cellType: "1",
						cellVal: "240040043.08"
					},
				},{
					title: "现金流入小计",
					grade: '44',
					disabledcwbbqykjzd_2_x_1: false,
					cwbbqykjzd_2_x_1: {
						cellCode: "cwbbwxz_1_16_1",
						cellType: "1",
						cellVal: "240040043.08"
					},
				},{
					title: "偿还债务所支付的现金",
					grade: '45',
					disabledcwbbqykjzd_2_x_1: false,
					cwbbqykjzd_2_x_1: {
						cellCode: "cwbbwxz_1_16_1",
						cellType: "1",
						cellVal: "240040043.08"
					},
				},{
					title: "分配股利、利润或偿付利息所支付的现金",
					grade: '46',
					disabledcwbbqykjzd_2_x_1: false,
					cwbbqykjzd_2_x_1: {
						cellCode: "cwbbwxz_1_16_1",
						cellType: "1",
						cellVal: "240040043.08"
					},
				},{
					title: "支付的其他与筹资活动有关的现金",
					grade: '52',
					disabledcwbbqykjzd_2_x_1: false,
					cwbbqykjzd_2_x_1: {
						cellCode: "cwbbwxz_1_16_1",
						cellType: "1",
						cellVal: "240040043.08"
					},
				},{
					title: "现金流出小计",
					grade: '53',
					disabledcwbbqykjzd_2_x_1: false,
					cwbbqykjzd_2_x_1: {
						cellCode: "cwbbwxz_1_16_1",
						cellType: "1",
						cellVal: "240040043.08"
					},
				},{
					title: "筹资活动产生的现金流量净额",
					grade: '54',
					disabledcwbbqykjzd_2_x_1: false,
					cwbbqykjzd_2_x_1: {
						cellCode: "cwbbwxz_1_16_1",
						cellType: "1",
						cellVal: "240040043.08"
					},
				},{
					title: "四、汇率变动对现金的影响",
					grade: '55',
					disabledcwbbqykjzd_2_x_1: false,
					cwbbqykjzd_2_x_1: {
						cellCode: "cwbbwxz_1_16_1",
						cellType: "1",
						cellVal: "240040043.08"
					},
				},{
					title: "五、现金及现金等价物净增加额",
					grade: '56',
					disabledcwbbqykjzd_2_x_1: false,
					cwbbqykjzd_2_x_1: {
						cellCode: "cwbbwxz_1_16_1",
						cellType: "1",
						cellVal: "240040043.08"
					},
				},{
					title: "补充资料：",
					disabledcwbbqykjzd_2_x_1: false,
					cwbbqykjzd_2_x_1: {cellCode: "cwbbwxz_1_17_1",},
				}
			]
		
	}
	return obj
}
